// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vcIRoFjKxlQY3GXhIjGr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 1rem 1.5rem;
  background-color: var(--white);
  border-radius: var(--panel-narrow-border-radius);
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
  border: 0.0625rem solid var(--grey-200);
  margin-bottom: 1rem;
}

.oLZJBzrlVomq0kE8NUlH {
  margin-right: 0.75rem;
}

.UlFAjBHevLLJoyTjTAr8 {
  flex: 0 0 auto;
  width: 4.875rem;
  height: 3.1875rem;
  background-size: cover;
  background-position: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/TinyProductCard/TinyProductCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA4B;EAC5B,8BAA8B;EAC9B,gDAAgD;EAChD,8CAAuC;EACvC,uCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,qBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAW;EACX,iBAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":[".tinyProductCard {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 16px 16px 24px;\n  background-color: var(--white);\n  border-radius: var(--panel-narrow-border-radius);\n  box-shadow: 0 4px 12px var(--black-012);\n  border: 1px solid var(--grey-200);\n  margin-bottom: 16px;\n}\n\n.title {\n  margin-right: 12px;\n}\n\n.cardContainer {\n  flex: 0 0 auto;\n  width: 78px;\n  height: 51px;\n  background-size: cover;\n  background-position: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tinyProductCard": `vcIRoFjKxlQY3GXhIjGr`,
	"title": `oLZJBzrlVomq0kE8NUlH`,
	"cardContainer": `UlFAjBHevLLJoyTjTAr8`
};
export default ___CSS_LOADER_EXPORT___;
